var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBell = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.023 12.5c0-4.5-4-3.5-4-7q-.001-.434-.079-.749c-.263-1.766-1.44-3.183-2.965-3.615A1 1 0 0 0 9 .945C9 .425 8.55 0 8 0S7 .425 7 .945q0 .098.021.191c-1.71.484-2.983 2.208-3.02 4.273L4 5.5C4 9 0 8 0 12.5c0 1.191 2.665 2.187 6.234 2.439a2 2 0 0 0 3.532 0C13.334 14.688 16 13.691 16 12.5v-.011l.024.011zm-3.113.845c-.847.226-1.846.389-2.918.479a2 2 0 0 0-3.984 0c-1.072-.09-2.071-.253-2.918-.479-1.166-.311-1.724-.659-1.928-.845.204-.186.762-.534 1.928-.845 1.356-.362 3.1-.561 4.91-.561s3.554.199 4.91.561c1.166.311 1.724.659 1.928.845-.204.186-.762.534-1.928.845"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell.svg";